// extracted by mini-css-extract-plugin
module.exports = {"section":"Airlines_section__Zf7yS","image":"Airlines_image__noid2"};